/**
 * Dentterity testimonials
 * Adds accessible pagination controls to the mobile native scroll-snap carousel.
 */
(() => {
  const selector = '[data-dt-testimonials]';

  const initialise = (section) => {
    if (section.dataset.dtTestimonialsInitialised === 'true') return;

    const viewport = section.querySelector('[data-dt-testimonials-viewport]');
    const slides = [...section.querySelectorAll('.dt-testimonials__slide')];
    const pagination = section.querySelector('[data-dt-testimonials-pagination]');

    if (!viewport || !pagination || slides.length < 2) return;

    section.dataset.dtTestimonialsInitialised = 'true';

    const dots = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.className = 'dt-testimonials__dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show testimonial ${index + 1}`);
      dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');

      dot.addEventListener('click', () => {
        viewport.scrollTo({
          left: slide.offsetLeft - viewport.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      });

      pagination.append(dot);
      return dot;
    });

    const updateActiveDot = () => {
      const viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
      let activeIndex = 0;
      let nearestDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(viewportCenter - slideCenter);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      });
    };

    let animationFrame;

    viewport.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(animationFrame);
        animationFrame = requestAnimationFrame(updateActiveDot);
      },
      { passive: true }
    );
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll(selector).forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll(), { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();